enum ActionTypes {
  SET_LOCATION_MANAGEMENT_ID = 'locationManagement/SET_LOCATION_MANAGEMENT_ID',
}

export default ActionTypes;
